import { render } from "./vdvcorderranking.vue?vue&type=template&id=63fb1062&scoped=true"
import script from "./vdvcorderranking.vue?vue&type=script&lang=js"
export * from "./vdvcorderranking.vue?vue&type=script&lang=js"

import "./vdvcorderranking.vue?vue&type=style&index=0&id=63fb1062&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fb1062"]])

export default __exports__